// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyCwbcI7tPR3eWLavnWkGIUZ1JPwhPoax-o",
    authDomain: "day-care-app.firebaseapp.com",
    databaseURL: "https://day-care-app.firebaseio.com",
    projectId: "day-care-app",
    storageBucket: "day-care-app.appspot.com",
    messagingSenderId: "923988811631",
    appId: "1:923988811631:web:1c7f1bda083a17a7"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
